export const getHeaderClasses = (level: number, textClass: string = '') => {
    switch (level) {
      case 2: return `${textClass} text-3xl`;
      case 3: return `${textClass} text-2xl`;
      case 4: return `${textClass} text-xl`;
      case 5: return `${textClass} text-lg`;
      case 6: return `${textClass} text-base`;
      default: return '';
    }
  };